import { atom } from "jotai";
import type { GpuVerdict, VerdictReason } from "../utils/gpuVerdict";

/** App-wide GPU-capability verdict. Initialized to "volume-ok" so a probe
 *  failure or pre-probe render uses the unrestricted path. The boot probe
 *  in App.tsx overwrites this once on mount. */
export const gpuVerdictAtom = atom<GpuVerdict>("volume-ok");

/** Why the boot probe reached {@link gpuVerdictAtom}'s value. Set alongside it
 *  at boot; null only before the probe runs. Lets the 2D banner tell a
 *  denylisted GPU (a reload can't help) from a transient probe failure. */
export const gpuVerdictReasonAtom = atom<VerdictReason | null>(null);
